<template>
  <div>
    <div class="mb-10 p-6">
      <h2 class="mb-4">{{ $t('CONTENT.charts.payments_chart') }}</h2>

      <div v-if="contractObj.assetComponents.length > 5">
      <cool-select class = "mb-5"
                   :list="contractObj.assetComponents"
                   option-value="assetId"
                   :custom-text="(assetComponent)=>getAssetName(assetComponent.assetId) + ' Внешний Id: ' + assetComponent.assetExternalId"
                   :placeholder="$t('CONTENT.choose')"
                   v-model="selectedAssetComponent"
      />
      <li
        class="b-payments__tabs-list-item mr-4"
        @click="paymentActiveTab=`totalPaymentChart`"
        :key="`totalPaymentChart`"
      >
        <a
          class="b-tabs__list-item-link"
          :class="[ paymentActiveTab == `totalPaymentChart` ? 'router-link-active' : '' ]"
        >Итого платежей</a>
      </li>
      </div>
      <ul class="b-tabs__list mb-4" v-else>
        <li
          v-for="(component, assetComponentIndex) in contractObj.assetComponents"
          class="b-payments__tabs-list-item mr-4"
          @click="paymentActiveTab=`${assetComponentIndex}`"
          :key="`${assetComponentIndex}`"
        >
          <a
            class="b-tabs__list-item-link"
            :class="[ paymentActiveTab == `${assetComponentIndex}` ? 'router-link-active' : '' ]"
          >{{ getAssetName(component.assetId) }} {{ getAssetComponentName(component) }}</a>
        </li>
        <li
          class="b-payments__tabs-list-item mr-4"
          @click="paymentActiveTab=`totalPaymentChart`"
          :key="`totalPaymentChart`"
        >
          <a
            class="b-tabs__list-item-link"
            :class="[ paymentActiveTab == `totalPaymentChart` ? 'router-link-active' : '' ]"
          >Итого платежей</a>
        </li>
      </ul>
      <div class="b-tabs">
        <payment-chart-widget
          :contractId="contractId"
          v-if="paymentActiveTab != `totalPaymentChart`"
          :component="contractObj.assetComponents[paymentActiveTab]"
          :currentVersionId="currentVersionId"
        />
        <total-payment-chart-widget
          :contractId="contractId"
          v-if="paymentActiveTab == `totalPaymentChart`"
          :components="contractObj.assetComponents"
          :currentVersionId="currentVersionId"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import LiabilitiesEdit from "./LiabilitiesEdit";


export default {
  props: ['baseContractObj'],
  components: {
    LiabilitiesEdit
  },
  data() {
    return {
      paymentActiveTab: null,
      contractObj: {},
      selectedAssetComponent: null,
    };
  },
  watch: {
    selectedAssetComponent(value) {
      console.log(`value: ${value}`);
      this.paymentActiveTab = this.contractObj.assetComponents.indexOf(value)
    },
  },
  created() {
    this.contractObj = this.baseContractObj;
    this.selectedAssetComponent = this.contractObj.assetComponents[0]
  },
  computed: {
    ...mapGetters([
      "getAssets",
      "getContractSettings",
      "getCurrentContract",
      "getPaymentNames"
    ]),
    contractId() {
      return this.$route.params.id;
    },
    currentVersionId() {
      if (this.$route.query.eventId) return this.$route.query.eventId;
      else return null;
    },
    assetNames() {
      const assetNames = {}
      this.getAssets.forEach(a => assetNames[a.idInDB] = a.name)
      return assetNames
    }
  },

  methods: {
    getAssetComponentName(component) {
      if (component.name !== null) {
        return ` - ${component.name}`;
      }
    },
    getAssetName(assetId) {
      return this.assetNames[assetId]
    },
  },
};
</script>

